export const FAQS = [
  {
    q: "Does Thermo Edge manufacture the insulation you sell?",
    a: "Thermo Edge is an authorized dealer and solutions provider. We supply premium insulation from vetted manufacturers, and we handle technical consultation, installation and after-sales service end-to-end.",
  },
  {
    q: "Do you provide free site inspection?",
    a: "Yes. Free site inspection is included with every quotation across Bihar. Our engineer will measure, document heat load, and give you a specification-backed proposal within 48 hours.",
  },
  {
    q: "How long does insulation installation take?",
    a: "A typical 10,000 sqft warehouse is completed in 3–5 working days. Poultry sheds and smaller commercial buildings can be done in 1–2 days depending on access.",
  },
  {
    q: "What kind of temperature reduction can I expect?",
    a: "For a metal-roofed warehouse with 6mm double-foil bubble insulation and a proper 25mm air gap, we routinely see 8–15°C drop in peak indoor temperature.",
  },
  {
    q: "Do you install outside Bihar?",
    a: "Yes — we take pan-India projects on request. Coordination is handled from our Bihar base and installation is executed by our regional partner teams.",
  },
  {
    q: "Why don't you show prices on the website?",
    a: "Every project has different roof pitch, span, material choice, and installation complexity. A one-line price would be dishonest. We give a firm written quote within 48 hours of site inspection.",
  },
  {
    q: "Is your insulation fire-safe?",
    a: "All products we supply carry a Class B (self-extinguishing) fire rating or better. Test certificates are shared with every quotation.",
  },
  {
    q: "What after-sales support do you provide?",
    a: "Every installation carries a workmanship warranty. We inspect after the first monsoon at no cost and provide priority response for any repair or top-up needs.",
  },
];
